module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zZbwqf/tc-custom/9781459294585.jpg?1721429532022",
      "alt": "This image is the cover for the book Tempted, Eden's Children"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tempted, Eden's Children\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The frightened woman standing before millionaire Jared Spencer hardly looked like the housekeeper's spirited daughter who'd once captured his heart then betrayed him. But the moment their gazes met, he felt the same fiery, forbidden desire. Tess Campbell had come with a plea to help find her missing child. A child who should have been theirs. Tess tempted fate by going to Jared. But for her little girl, she'd face the devil himself. Jared's millions would fuel the search—but it was the man Tess needed to keep her safe. For when Jared learned her precious secret, he and Tess would be in more danger than their daughter…"), _c('br'), _c('br'), _vm._v("Previously Published.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Stevens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amanda Stevens is an award-winning author of over fifty novels. Born and raised in the rural south, she now resides in Houston, Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0